import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CampaignQuietStore {
  // Campaigns with quiet mode on: stage transitions send quiet=true so no influencer notifications go out.
  quietCampaignIds: Record<string, true>;
  isQuiet: (campaignId: string) => boolean;
  toggleQuiet: (campaignId: string) => void;
}

export const useCampaignQuietStore = create<CampaignQuietStore>()(
  persist(
    (set, get) => ({
      quietCampaignIds: {},

      isQuiet: (campaignId) => get().quietCampaignIds[campaignId] === true,

      toggleQuiet: (campaignId) =>
        set((state) => {
          const next = { ...state.quietCampaignIds };
          if (next[campaignId]) delete next[campaignId];
          else next[campaignId] = true;
          return { quietCampaignIds: next };
        }),
    }),
    {
      name: "campaign-quiet-mode",
    },
  ),
);
